import {
  PRCategoryTableData,
  PRCategoryTableRow,
  PRCategoryResponse,
  PRCategoryApiData,
} from '@app/models/pr_categories/PRCategoryResponse';
import { post, get } from './http.api';
import { Parameters } from '@app/models/Parameters';
import { PRCategoryRequest } from '@app/models/pr_categories/PRCategoryRequest';

export const getPRCategoryTableData = async (parameters: Parameters): Promise<PRCategoryTableData> => {
  try {
    const { data, status } = await get<any>('pr_categories', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const PRCategories: PRCategoryTableRow[] = data?.pr_categories?.data?.map((PRCategoriesData: any) => ({
      id: PRCategoriesData.id,
      code: PRCategoriesData.code,
      name: PRCategoriesData.name,
      parent_id: PRCategoriesData.parent_id,
      status: PRCategoriesData.status,
    }));

    return {
      data: PRCategories,
      status_options: data.status_options,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Departments:', error);
    throw error;
  }
};

export const getAllPRCategories = async (): Promise<PRCategoryResponse> => {
  try {
    const { data, status } = await get<PRCategoryResponse>(`pr_categories`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getPRCategoryById = async (id: number): Promise<PRCategoryResponse> => {
  try {
    const { data, status } = await get<PRCategoryResponse>(`pr_categories/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storePRCategory = async (DepartmentData: PRCategoryRequest) => {
  try {
    const response = await post<any>('pr_categories/create', DepartmentData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createPRCategory = async (): Promise<PRCategoryApiData> => {
  try {
    const { data, status } = await get<PRCategoryApiData>(`pr_categories/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showPRCategory = async (id: number) => {
  try {
    const { data, status } = await get<PRCategoryApiData>(`pr_categories/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editPRCategory = async (id: number) => {
  try {
    const { data, status } = await get<PRCategoryApiData>(`pr_categories/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updatePRCategory = async (id: number, Updatecategory: PRCategoryRequest) => {
  try {
    const { data, status } = await post<PRCategoryRequest>(`pr_categories/${id}/edit`, Updatecategory, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
